const ja: Record<string, string> = {
  "Virtual Try-On": "バーチャル試着",
  "Find Your Size & See It On You": "あなたのサイズを見つけて試着",
  "See Your Fit": "フィット感を見る",
  "Check your size, then try it on virtually": "サイズを確認して、バーチャルで試着しましょう",
  "Get Your Size": "サイズを確認",
  "Instant fit suggestion": "瞬時にフィット提案",
  "Try It On": "試着する",
  "See how it looks on you": "自分に似合うか確認",
  "Find My Size": "自分のサイズを見つける",
  "Takes less than a minute": "1分もかかりません",
  "Upload a full body photo": "全身写真をアップロード",
  "JPEG, PNG or WebP (max 10MB)": "JPEG、PNG、WebP（最大10MB）",
  "Your photo": "あなたの写真",
  "Let's find your best fit": "最適なフィットを見つけましょう",
  "Centimeters": "センチメートル",
  "Inches": "インチ",
  "Load saved profile...": "保存済みプロファイルを読み込む...",
  "HEIGHT": "身長",
  "WEIGHT": "体重",
  "feet": "フィート",
  "inches": "インチ",
  "cm": "cm",
  "kg": "kg",
  "lbs": "ポンド",
  "in": "インチ",
  "How to measure": "測り方",
  "Hide guide": "ガイドを隠す",
  "I know my measurements": "自分の寸法を知っています",
  "Not sure? Use height & weight instead": "分からない場合は身長と体重で",
  "Please fill in height and weight": "身長と体重を入力してください",
  "Please fill in all required fields": "すべての必須項目を入力してください",
  "Next": "次へ",
  "Analyzing your size...": "サイズを分析中...",
  "SUGGESTED SIZE": "提案サイズ",
  "NOT SUGGESTED": "提案外",
  "Edit measurements": "寸法を編集",
  "Size guide": "サイズガイド",
  "Your fit": "あなたのフィット",
  "Your Suggested Size": "提案サイズ",
  "Your measure": "あなたの寸法",
  "within range": "範囲内",
  "too tight": "きつすぎる",
  "tight": "きつい",
  "a bit tight": "少しきつい",
  "too loose": "ゆるすぎる",
  "loose": "ゆるい",
  "a bit loose": "少しゆるい",
  "See fit on your photo": "写真でフィットを確認",
  "Hide visual fit": "フィット表示を隠す",
  "Analyzing...": "分析中...",
  "Try it on": "試着する",
  "SIZE CHART": "サイズ表",
  "YOUR ESTIMATED MEASUREMENTS": "推定寸法",
  "Edit": "編集",
  "Download": "ダウンロード",
  "Size chart": "サイズ表",
  "Preparing your image...": "画像を準備中...",
  "Analyzing body proportions...": "体型を分析中...",
  "Matching garment to your photo...": "衣類を写真に合わせています...",
  "Generating virtual try-on...": "バーチャル試着を生成中...",
  "Refining details...": "細部を調整中...",
  "Almost there...": "もう少しです...",
  "Complete!": "完了！",
  "This usually takes 15-25 seconds": "通常15〜25秒かかります",
  "Something went wrong": "エラーが発生しました",
  "Try Again": "もう一度試す",
  "We couldn't find a matching size for you": "一致するサイズが見つかりませんでした",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "手入力の採寸画面を使うと、入力した寸法からフィットを計算できます。",
  "Try manual measurements": "手入力で採寸する",
  "SDK not configured. Please provide an API key.": "SDKが設定されていません。APIキーを入力してください。",
  "Please upload a JPEG, PNG, or WebP image.": "JPEG、PNG、WebP画像をアップロードしてください。",
  "Image must be under 10MB.": "画像は10MB以下にしてください。",
  "Try-on generation failed": "試着の生成に失敗しました",
  "Failed to start try-on": "試着の開始に失敗しました",
  "No product image found. Please set the product-image attribute.": "商品画像が見つかりません。product-image属性を設定してください。",
  "Powered by": "Powered by",
  "My Profiles": "マイプロファイル",
  "History": "履歴",
  "No saved profiles yet.": "保存済みプロファイルはありません。",
  "No history yet.": "履歴はまだありません。",
  "Product": "商品",
  "Women's": "レディース",
  "Men's": "メンズ",
  "Profiles": "プロファイル",
  "Women's Profile": "レディースプロファイル",
  "Men's Profile": "メンズプロファイル",
  "Height": "身長",
  "Weight": "体重",
  "Chest": "胸囲",
  "Bust": "バスト",
  "Waist": "ウエスト",
  "Hips": "ヒップ",
  "Shoulders": "肩幅",
  "Sleeve": "袖丈",
  "Inseam": "股下",
  "Neck": "首周り",
  "Foot": "足",
  "Shoe EU": "靴 EU",
  "Shoe US": "靴 US",
  "Shoe UK": "靴 UK",
  "Saved": "保存済み",
  "Delete Profile": "プロファイルを削除",
  "Shoe size (US)": "靴のサイズ（US）",
  "Shoe size (UK)": "靴のサイズ（UK）",
  "Shoe size (EU)": "靴のサイズ（EU）",
  "Generating...": "生成中...",
  "Foot length": "足の長さ",
  "Size": "サイズ",
  "Try on size": "サイズを試着",
  "e.g.": "例",
  "Drop your photo here or click to upload": "ここに写真をドロップまたはクリックしてアップロード",
  "This usually takes 15-20 seconds": "通常15〜20秒かかります",
  "Try-on result": "試着結果",
  "Try Another": "別のものを試す",
  "Back": "戻る",
  "You": "あなた",
  "Garment": "衣類",
  "Your Height": "身長",
  "Your Weight": "体重",
  "Drag or scroll to set your height": "ドラッグまたはスクロールで身長を設定",
  "Drag or scroll to set your weight": "ドラッグまたはスクロールで体重を設定",
  "Enter height and weight first": "先に身長と体重を入力してください",

  // ── Field labels ──
  "Lens Width": "レンズ幅",
  "Bridge": "ブリッジ",
  "Arm Length": "テンプル長",
  "Head Circumference": "頭囲",
  "Face Width": "顔幅",
  "Temple": "テンプル",
  "Around widest point": "最も広い部分の周囲",
  "Foot Length": "足長",
  "Shoulder": "肩幅",
  "Thigh": "太もも",
  "Hip": "ヒップ",

  // ── Units ──
  "Millimetre": "ミリメートル",
  "Centimetre": "センチメートル",
  "Millimeters": "ミリメートル",

  // ── Fit descriptors ──
  "Tight": "きつい",
  "Loose": "ゆるい",
  "Short": "短い",
  "Long": "長い",
  "✓ Fit": "✓ フィット",
  "too short": "短すぎる",
  "too long": "長すぎる",
  "a bit short": "少し短い",
  "a bit long": "少し長い",

  // ── Length pills ──
  "Length": "丈",
  "Length Adjustment": "丈の調整",
  "Regular": "レギュラー",
  "Big": "ビッグ",
  "Big & Tall": "ビッグ & トール",

  // ── Misc ──
  "preview": "プレビュー",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "写真をアップロード",
  "Upload a photo": "写真をアップロード",
  "Click or drag a full-body photo": "全身写真をクリックまたはドラッグしてください",
  "Or upload a photo for AI sizing": "またはAIサイジング用の写真をアップロード",
  "Photo": "写真",
  "How to take a good photo": "良い写真の撮り方",
  "How to take the best photo": "最適な写真の撮り方",
  "Do": "推奨事項",
  "Don't": "避けるべき",
  "Quick Tip": "ワンポイント",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "シンプルな写真ほど、バーチャル試着の精度が高まります。",
  "Choose a plain background (a light wall is ideal)": "無地の背景を選んでください(明るい壁が理想的)",
  "Stand facing the camera with your full body in frame": "全身が写るようにカメラに正対して立ってください",
  "Stand straight and still, arms relaxed by your sides": "まっすぐ静止し、腕を自然に脇に下ろしてください",
  "Stand with your HEELS against a wall for best accuracy": "精度を高めるためにかかとを壁につけて立ってください",
  "Use natural or even lighting (e.g. near a window)": "自然光または均一な照明を使用してください(例:窓の近く)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "体にフィットしたシンプルな服を着てください(例:無地の色)",
  "Don't wear loose, baggy, or layered clothing": "ゆったりした服や重ね着は避けてください",
  "Don't sit, pose, or bend your body": "座ったり、ポーズを取ったり、体を曲げたりしないでください",
  "Don't use strong backlighting": "強い逆光を使用しないでください",
  "Don't take mirror photos or selfies": "鏡越しや自撮りは避けてください",
  "Don't apply filters, effects, or edits": "フィルターやエフェクト、加工は加えないでください",

  // ── Age gate ──
  "Are you 18 or older?": "18歳以上ですか?",
  "Yes": "はい",
  "No": "いいえ",
  "Please confirm your age": "年齢を確認してください",
  "Please confirm that the person in the photo is 18 or older before uploading.": "アップロードする前に、写真の人物が18歳以上であることを確認してください。",
  "Under 18 — can't process this photo.": "18歳未満です — この写真は処理できません。",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "この写真は未成年者のようです。18歳以上の人物の写真をアップロードしてください。",
  "Different photo needed": "別の写真が必要です",
  "Try another photo": "別の写真をお試しください",

  // ── Photo step controls ──
  "Continue": "続ける",
  "Analyze My Size": "サイズを分析",
  "Analyzing photo…": "写真を分析中…",
  "Details": "詳細",
  "Image must be under 10MB": "画像は10MB以下である必要があります",
  "Please upload an image file": "画像ファイルをアップロードしてください",
  "Please upload a photo": "写真をアップロードしてください",
  "Prefer not to upload a photo?": "写真をアップロードしませんか?",
  "Enter measurements manually": "手動でサイズを入力",
  "Legal Notice": "法的通知",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "あなたの画像は、選択したアイテムの見え方とフィット感を示すバーチャル試着プレビューを生成するために使用されます。画像は安全に処理され、生成後は保存されません。",

  // ── BodyProfileView — form (right section) ──
  "Body details": "体型情報",
  "Your body details": "あなたの体型情報",
  "Body Measurements": "サイズ",
  "AGE": "年齢",
  "years": "歳",
  "Enter your height": "身長を入力してください",
  "Enter your weight": "体重を入力してください",
  "Enter your bra size": "ブラのサイズを入力してください",
  "Please enter your height": "身長を入力してください",
  "Please enter your weight": "体重を入力してください",
  "Please enter a valid height": "有効な身長を入力してください",
  "Please enter a valid weight": "有効な体重を入力してください",
  "Please enter a valid height (100-250 cm)": "有効な身長を入力してください(100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "有効な体重を入力してください(30-300 kg)",
  "Please select both band and cup size": "アンダーとカップのサイズを選択してください",
  "Select your bra size": "ブラのサイズを選択してください",
  "BAND": "アンダー",
  "BAND SIZE": "アンダーサイズ",
  "CUP": "カップ",
  "CUP SIZE": "カップサイズ",
  "BRA REGION": "ブラ地域",
  "Imperial": "ヤード・ポンド法",
  "Metric": "メートル法",
  "These calibrate the AI — all required.": "これらはAIを較正するための必須項目です。",
  "Using": "使用中",
  "start fresh": "最初からやり直す",
  "Close": "閉じる",

  // ── Body shape questions ──
  "Which best describes your chest?": "胸の特徴に最も近いものは?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "胸の特徴に最も近いものは?",
  "Which best describes your hips?": "ヒップの特徴に最も近いものは?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "ヒップの特徴に最も近いものは?",
  "Which best describes your midsection?": "ウエストの特徴に最も近いものは?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "ウエストの特徴に最も近いものは?",
  "Which best describes your seat?": "おしりの特徴に最も近いものは?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "おしりの特徴に最も近いものは?",
  "Average": "平均",
  "Narrow": "細い",
  "Broad": "広い",
  "Curvy": "曲線的",
  "A slimmer, narrower chest build": "細くてスリムな胸",
  "A moderate, proportionate chest": "標準的でバランスの良い胸",
  "A wider, more muscular chest": "広く筋肉質な胸",
  "A flatter midsection with minimal protrusion": "出っ張りが少ない平らなウエスト",
  "A moderate, natural midsection shape": "標準的で自然なウエスト",
  "A fuller, more rounded midsection": "丸みのあるふくよかなウエスト",
  "A flatter backside with less projection": "突出の少ない平らなおしり",
  "A moderate, natural backside shape": "標準的で自然なおしり",
  "A fuller, more rounded backside": "丸みのあるふくよかなおしり",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "プロフィールから読み込み",
  "Clear": "クリア",
};
export default ja;
